import { useEffect, useState } from 'react';

export const CONDUCTOR_WIDGET_HINT = 'You can always access Conductor here';
const HINT_DURATION_MS = 6000;

const useConductorWidgetHint = () => {
  const [showHint, setShowHint] = useState(false);

  useEffect(() => {
    let timeoutId = null;
    const handleDismissed = () => {
      setShowHint(true);
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => setShowHint(false), HINT_DURATION_MS);
    };
    window.addEventListener('conductorWidgetDismissed', handleDismissed);
    return () => {
      window.removeEventListener('conductorWidgetDismissed', handleDismissed);
      clearTimeout(timeoutId);
    };
  }, []);

  return [showHint, () => setShowHint(false)];
};

export default useConductorWidgetHint;
